import React from "react";
import PropTypes from "prop-types";
import { inputClassName } from "cxa-components/textfield";
import ReactAutocomplete from "react-autocomplete";
class Autocomplete extends React.Component {
  constructor() {
    super();
  }
  // componentDidMount() {
  //   !!this.props.value && this.input.focus();
  // }

  render() {
    const { error, value, valueKey, labelKey, onChange, onBlur, ...rest } = this.props;
    const inputProps = {
      className: inputClassName(this.props),
      onBlur: e => onBlur(value),
    };
    return (
      <ReactAutocomplete
        {...rest}
        ref={el => (this.input = el)}
        onChange={(event, value) => onChange(value)}
        onSelect={value => onChange(value)}
        value={value}
        wrapperStyle={{ position: "relative" }}
        inputProps={inputProps}
        getItemValue={item => item.label}
        shouldItemRender={(item, value) =>
          item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1 ||
          item.label.toLowerCase().indexOf(value.toLowerCase()) !== -1
        }
        renderItem={(item, isHighlighted) => (
          <div className={isHighlighted ? "autocomplete__item--highlight" : ""} key={item.name}>
            {item.label}
          </div>
        )}
        renderMenu={(items, value, style) => (
          <div className="autocomplete" style={items.length == 0 ? { display: "none" } : null}>
            {items}
          </div>
        )}
      />
    );
  }
}

Autocomplete.propTypes = {
  error: PropTypes.string,
  value: PropTypes.string,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default Autocomplete;



// WEBPACK FOOTER //
// ./casper/sass/components/autocomplete/autocomplete.js